/* MILLENNIUM.NYC theme JS
   Cart drawer (AJAX Cart API + Section Rendering), lead-capture forms with
   inline confirmation, PDP gallery, filter panels, qty steppers, mobile menu. */
(function () {
  'use strict';

  var root = document.documentElement;
  var routes = window.MillenniumRoutes || { cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_url: '/cart' };

  /* ---------------- cart drawer ---------------- */

  function drawerEl() { return document.getElementById('CartDrawer'); }

  function openDrawer() {
    if (!drawerEl()) return;
    document.body.classList.add('drawer-open');
    document.body.style.overflow = 'hidden';
    var closeBtn = drawerEl().querySelector('.dw-head__close');
    if (closeBtn) closeBtn.focus({ preventScroll: true });
  }

  function closeDrawer() {
    document.body.classList.remove('drawer-open');
    document.body.style.overflow = '';
  }

  function updateCartCount() {
    var d = drawerEl();
    if (!d) return;
    var count = d.getAttribute('data-item-count');
    if (count === null) return;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function replaceDrawer(html) {
    var d = drawerEl();
    if (!d || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('CartDrawer');
    if (fresh) {
      d.replaceWith(fresh);
      updateCartCount();
    }
  }

  function refreshDrawer(open) {
    return fetch(window.location.pathname + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        replaceDrawer(html);
        if (open) openDrawer();
      });
  }

  function addToCart(variantId, quantity, button) {
    if (button) { button.setAttribute('disabled', 'disabled'); button.setAttribute('aria-busy', 'true'); }
    return fetch(routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: quantity || 1 }],
        sections: 'cart-drawer'
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.sections && data.sections['cart-drawer']) {
          replaceDrawer(data.sections['cart-drawer']);
          openDrawer();
        } else if (data.status && data.status !== 200) {
          window.location.href = routes.cart_url;
        } else {
          return refreshDrawer(true);
        }
      })
      .catch(function () { window.location.href = routes.cart_url; })
      .finally(function () {
        if (button) { button.removeAttribute('disabled'); button.removeAttribute('aria-busy'); }
      });
  }

  function changeLine(line, quantity) {
    return fetch(routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: quantity, sections: 'cart-drawer' })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.sections && data.sections['cart-drawer']) replaceDrawer(data.sections['cart-drawer']);
        /* if we're on the cart page, keep it in sync */
        if (document.querySelector('.s-cartpage')) window.location.reload();
      });
  }

  /* ---------------- delegated clicks ---------------- */

  document.addEventListener('click', function (e) {
    var t;

    /* quick add (cards / attach rows) */
    t = e.target.closest('[data-add-variant]');
    if (t) {
      e.preventDefault();
      addToCart(t.getAttribute('data-add-variant'), 1, t);
      return;
    }

    /* open cart */
    t = e.target.closest('[data-cart-open]');
    if (t && drawerEl()) {
      e.preventDefault();
      refreshDrawer(true);
      return;
    }

    /* close cart */
    if (e.target.closest('[data-cart-close]') || (e.target.classList && e.target.classList.contains('m-scrim'))) {
      closeDrawer();
      return;
    }

    /* drawer line qty +/- */
    t = e.target.closest('[data-line-change]');
    if (t) {
      e.preventDefault();
      changeLine(t.getAttribute('data-line'), Number(t.getAttribute('data-line-change')));
      return;
    }

    /* generic qty stepper +/- */
    t = e.target.closest('[data-qty-change]');
    if (t) {
      var input = t.closest('.m-qty').querySelector('input');
      var next = Math.max(1, (parseInt(input.value, 10) || 1) + Number(t.getAttribute('data-qty-change')));
      input.value = next;
      document.querySelectorAll('[data-qty-mirror]').forEach(function (m) {
        var mi = m.querySelector('input'); if (mi && mi !== input) mi.value = next;
      });
      return;
    }

    /* mobile menu */
    if (e.target.closest('[data-menu-open]')) {
      document.getElementById('MobileMenu').classList.add('is-open');
      document.body.style.overflow = 'hidden';
      return;
    }
    if (e.target.closest('[data-menu-close]')) {
      document.getElementById('MobileMenu').classList.remove('is-open');
      document.body.style.overflow = '';
      return;
    }

    /* filter dropdown toggles */
    t = e.target.closest('[data-filter-toggle]');
    if (t) {
      var wrap = t.closest('.m-filter');
      var wasOpen = wrap.classList.contains('is-open');
      document.querySelectorAll('.m-filter.is-open').forEach(function (f) { f.classList.remove('is-open'); });
      if (!wasOpen) wrap.classList.add('is-open');
      return;
    }
    if (!e.target.closest('.m-filter')) {
      document.querySelectorAll('.m-filter.is-open').forEach(function (f) { f.classList.remove('is-open'); });
    }

    /* PDP thumbnails */
    t = e.target.closest('[data-thumb-index]');
    if (t) {
      e.preventDefault();
      var gallery = t.closest('.pdp-gallery');
      var main = gallery.querySelector('.pdp-main img');
      var img = t.querySelector('img');
      if (main && img) {
        main.src = img.getAttribute('data-full') || img.src;
        main.srcset = img.getAttribute('data-full-srcset') || '';
        main.alt = img.alt || '';
      }
      gallery.querySelectorAll('.pdp-thumb').forEach(function (th) { th.classList.remove('is-active'); });
      t.classList.add('is-active');
      var pager = gallery.querySelector('.pdp-pager [data-pager-current]');
      if (pager) pager.textContent = Number(t.getAttribute('data-thumb-index')) + 1;
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDrawer();
      var menu = document.getElementById('MobileMenu');
      if (menu && menu.classList.contains('is-open')) {
        menu.classList.remove('is-open');
        document.body.style.overflow = '';
      }
      document.querySelectorAll('.m-filter.is-open').forEach(function (f) { f.classList.remove('is-open'); });
    }
  });

  /* ---------------- forms ---------------- */

  document.addEventListener('submit', function (e) {
    var form = e.target;

    /* product form → AJAX add, open drawer */
    if (form.matches('[data-product-form]')) {
      e.preventDefault();
      var id = form.querySelector('[name="id"]').value;
      var qtyInput = form.querySelector('[name="quantity"]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      addToCart(id, qty, form.querySelector('[type="submit"]'));
      return;
    }

    /* lead capture (notify / registry / concierge) → post, inline confirmation */
    var captureWrap = form.closest('[data-ajax-capture]');
    if (captureWrap) {
      e.preventDefault();
      var email = form.querySelector('input[type="email"]');
      if (email && !email.checkValidity()) { email.reportValidity(); return; }
      var body = new FormData(form);
      fetch(form.getAttribute('action') || '/contact', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: body
      }).catch(function () { /* confirmation is optimistic; submission is fire-and-forget */ });
      var done = document.createElement('div');
      done.className = 'm-capture-done';
      done.textContent = captureWrap.getAttribute('data-success') || "YOU'RE ON THE LIST ✓";
      captureWrap.replaceWith(done);
      return;
    }
  });

  /* ---------------- collection filters ---------------- */

  var filterForm = document.getElementById('CollectionFilters');
  if (filterForm) {
    filterForm.addEventListener('change', function (e) {
      /* radio is load-bearing: SORT is built from radios and has no submit button, so
         omitting it here made the entire sort dropdown a no-op. */
      if (e.target.matches('input[type="checkbox"], input[type="radio"], select')) filterForm.submit();
    });
  }

  /* ---------------- header search (expanding + predictive) ---------------- */

  var searchPanel = document.getElementById('HeaderSearch');
  if (searchPanel) {
    var searchInput = searchPanel.querySelector('[data-search-input]');
    var searchResults = searchPanel.querySelector('[data-search-results]');
    var searchTimer = null;
    var searchSeq = 0;

    function openSearch() {
      searchPanel.hidden = false;
      document.querySelectorAll('[data-search-open]').forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
      var menu = document.getElementById('MobileMenu');
      if (menu && menu.classList.contains('is-open')) {
        menu.classList.remove('is-open');
        document.body.style.overflow = '';
      }
      requestAnimationFrame(function () { searchInput.focus(); });
    }
    function closeSearch() {
      searchPanel.hidden = true;
      document.querySelectorAll('[data-search-open]').forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-search-open]');
      if (trigger) {
        e.preventDefault();
        if (searchPanel.hidden) openSearch(); else closeSearch();
        return;
      }
      if (e.target.closest('[data-search-close]')) { closeSearch(); return; }
      if (!searchPanel.hidden && !e.target.closest('#HeaderSearch')) closeSearch();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !searchPanel.hidden) { closeSearch(); return; }
      if (e.key === '/' && searchPanel.hidden && !e.target.closest('input, textarea, select, [contenteditable]')) {
        e.preventDefault();
        openSearch();
      }
    });

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    searchInput.addEventListener('input', function () {
      var q = searchInput.value.trim();
      clearTimeout(searchTimer);
      if (q.length < 2) { searchResults.innerHTML = ''; return; }
      searchTimer = setTimeout(function () {
        var seq = ++searchSeq;
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
              '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (seq !== searchSeq) return; /* a newer query is in flight */
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) {
              searchResults.innerHTML = '<div class="s-search__note">NOTHING ON THE SHELF — PRESS ENTER FOR FULL SEARCH, OR TRY THE WANT-LIST CONCIERGE.</div>';
              return;
            }
            searchResults.innerHTML = products.map(function (p) {
              var img = p.featured_image && p.featured_image.url;
              if (img) img += (img.indexOf('?') === -1 ? '?' : '&') + 'width=88';
              var thumb = img
                ? '<img class="s-search__thumb" src="' + escapeHtml(img) + '" width="44" height="44" alt="" loading="lazy">'
                : '<span class="s-search__thumb" aria-hidden="true"></span>';
              var meta = [p.type, p.available === false ? 'SOLD' : null].filter(Boolean).join(' · ');
              return '<a class="s-search__row" href="' + escapeHtml(p.url) + '">' +
                thumb +
                '<span class="s-search__row-main">' +
                  '<span class="s-search__row-title">' + escapeHtml(p.title) + '</span>' +
                  (meta ? '<span class="s-search__row-meta">' + escapeHtml(meta) + '</span>' : '') +
                '</span>' +
                '<span class="s-search__row-price">$' + escapeHtml(p.price) + '</span>' +
              '</a>';
            }).join('');
          })
          .catch(function () { /* predictive results are best-effort; Enter still reaches /search */ });
      }, 200);
    });
  }

  /* ---------------- registry lead-capture modal ---------------- */

  var leadModal = document.querySelector('[data-lead-modal]');
  if (leadModal) {
    var LEAD_KEY = 'mlm-registry-popup';

    function leadSuppressed() {
      try {
        var raw = localStorage.getItem(LEAD_KEY);
        if (!raw) return false;
        var state = JSON.parse(raw);
        if (state.joined) return true;
        return Date.now() < state.until;
      } catch (e) { return false; }
    }
    function suppressLead(days, joined) {
      try {
        localStorage.setItem(LEAD_KEY, JSON.stringify({
          until: Date.now() + days * 86400000,
          joined: !!joined
        }));
      } catch (e) { /* private browsing */ }
    }
    function openLead() { leadModal.hidden = false; document.body.style.overflow = 'hidden'; }
    function closeLead(joined) {
      leadModal.hidden = true;
      document.body.style.overflow = '';
      suppressLead(Number(leadModal.getAttribute('data-suppress-days')) || 14, joined);
    }

    var onCartOrCheckout = /^\/(cart|checkout)/.test(window.location.pathname);
    var designMode = window.Shopify && window.Shopify.designMode;

    if (designMode) {
      /* let merchants style it in the editor */
      document.addEventListener('shopify:section:select', function (e) {
        if (e.target.contains(leadModal)) leadModal.hidden = false;
      });
      document.addEventListener('shopify:section:deselect', function (e) {
        if (e.target.contains(leadModal)) leadModal.hidden = true;
      });
    } else if (!onCartOrCheckout && !leadSuppressed()) {
      setTimeout(openLead, (Number(leadModal.getAttribute('data-delay')) || 8) * 1000);
    }

    leadModal.addEventListener('click', function (e) {
      if (e.target.closest('[data-lead-close]')) closeLead(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !leadModal.hidden) closeLead(false);
    });
    leadModal.addEventListener('submit', function () {
      /* the shared data-ajax-capture handler swaps in the success note;
         mark joined so the popup never returns on this device */
      suppressLead(3650, true);
    });
  }

  /* ---------------- recent-sales toast ----------------
     Real cross-channel sales from recent-sales.json (Settings → Files,
     published by the ops dashboard). Quiet contract: max 2 per pageview
     (~15s and ~75s in), dismiss = silent for 24h, never on cart/checkout or
     THE RECORD, defers while the registry popup is open, no auto-show under
     prefers-reduced-motion beyond an instant (non-animated) appearance.
     Links are probed via /products/<handle>.js first — a sale on a channel
     can reference a product that's Draft here, and a 404 link would be worse
     than no link. Self-hides completely on any fetch failure or stale feed. */

  var salesToast = document.querySelector('[data-sales-toast]');
  if (salesToast && !/^\/(cart|checkout|blogs)/.test(window.location.pathname)) {
    var TOAST_KEY = 'mlm-sales-toast';
    var toastSuppressed = false;
    try {
      var state = JSON.parse(localStorage.getItem(TOAST_KEY) || '{}');
      toastSuppressed = state.until && Date.now() < state.until;
    } catch (e) { /* private browsing */ }

    if (!toastSuppressed) {
      var toastKicker = salesToast.querySelector('[data-toast-kicker]');
      var toastTitle = salesToast.querySelector('[data-toast-title]');
      var toastHideTimer = null;

      var toastAgo = function (iso) {
        var mins = Math.max(1, Math.round((Date.now() - new Date(iso).getTime()) / 60000));
        if (mins < 60) return mins + ' MIN AGO';
        var hours = Math.round(mins / 60);
        if (hours < 24) return hours + (hours === 1 ? ' HOUR' : ' HOURS') + ' AGO';
        var days = Math.round(hours / 24);
        return days + (days === 1 ? ' DAY' : ' DAYS') + ' AGO';
      };

      var toastThumb = salesToast.querySelector('[data-toast-thumb]');

      function toastShow(entry) {
        toastKicker.textContent = 'SOLD · ' + toastAgo(entry.sold_at);
        toastTitle.textContent = entry.title;
        toastTitle.removeAttribute('href');
        if (toastThumb) toastThumb.hidden = true;
        /* feed-supplied image first: the ops dashboard publishes product
           thumbnails for items with no live Shopify listing (TCG singles),
           so those toasts get card art too */
        if (entry.image && toastThumb) {
          toastThumb.querySelector('img').src =
            entry.image + (entry.image.indexOf('?') === -1 ? '?' : '&') + 'width=88';
          toastThumb.hidden = false;
        }
        if (entry.url) {
          /* one probe, two jobs: only link when the product is actually live
             on THIS store, and (absent a feed image) reuse its featured image */
          fetch(entry.url + '.js').then(function (r) {
            return r.ok ? r.json() : null;
          }).then(function (p) {
            if (!p) return;
            toastTitle.setAttribute('href', entry.url);
            var img = p.featured_image;
            if (img && toastThumb && toastThumb.hidden) {
              toastThumb.querySelector('img').src =
                img + (img.indexOf('?') === -1 ? '?' : '&') + 'width=88';
              toastThumb.hidden = false;
            }
          }).catch(function () {});
        }
        salesToast.hidden = false;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { salesToast.classList.add('is-shown'); });
        });
        clearTimeout(toastHideTimer);
        toastHideTimer = setTimeout(toastHide, 8000);
      }

      function toastHide() {
        salesToast.classList.remove('is-shown');
        setTimeout(function () { salesToast.hidden = true; }, 300);
      }

      function toastSchedule(entry, delay) {
        setTimeout(function () {
          /* commerce chrome outranks social proof: defer once if the registry
             popup is open or the cart drawer is out, then give up quietly */
          var modal = document.querySelector('[data-lead-modal]');
          var busy = (modal && !modal.hidden) || document.body.classList.contains('drawer-open');
          if (busy) {
            setTimeout(function () {
              var m = document.querySelector('[data-lead-modal]');
              if ((m && !m.hidden) || document.body.classList.contains('drawer-open')) return;
              toastShow(entry);
            }, 30000);
            return;
          }
          toastShow(entry);
        }, delay);
      }

      salesToast.addEventListener('click', function (e) {
        if (e.target.closest('[data-toast-close]')) {
          toastHide();
          try {
            localStorage.setItem(TOAST_KEY, JSON.stringify({ until: Date.now() + 86400000 }));
          } catch (err) { /* private browsing */ }
        }
      });

      fetch(salesToast.getAttribute('data-feed-url'))
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          var sales = (data && data.sales) || [];
          var fresh = sales.filter(function (s) {
            return s && s.title && s.sold_at &&
              Date.now() - new Date(s.sold_at).getTime() < 7 * 86400000;
          });
          if (!fresh.length) return; /* stale or empty feed — stay silent */
          toastSchedule(fresh[0], 15000);
          if (fresh.length > 1) toastSchedule(fresh[1], 75000);
        })
        .catch(function () { /* no feed yet — the toast simply never exists */ });
    }
  }

  /* ---------------- top nav: sliding underline ----------------
     One indicator that tracks the hovered link and settles back on the current page.
     Uses translateX + scaleX (compositor-only) rather than animating left/width.
     Without JS the nav keeps its static aria-current border — see .has-ink in base.css. */

  var navEl = document.querySelector('.s-header__nav');
  var navInk = navEl && navEl.querySelector('[data-nav-ink]');
  if (navEl && navInk) {
    var navLinks = navEl.querySelectorAll('a');
    var navCurrent = navEl.querySelector('a[aria-current="page"]');

    function inkTo(link, show) {
      if (!link) { navInk.style.opacity = '0'; return; }
      var navBox = navEl.getBoundingClientRect();
      var box = link.getBoundingClientRect();
      navInk.style.transform =
        'translateX(' + (box.left - navBox.left) + 'px) scaleX(' + box.width + ')';
      navInk.style.opacity = show ? '1' : '0';
    }

    function inkRest() { inkTo(navCurrent, !!navCurrent); }

    if (navLinks.length) {
      /* Position SYNCHRONOUSLY. .has-ink removes the static aria-current border, so if the
         ink were never placed the nav would have no active indicator at all — which is what
         happened when this ran inside requestAnimationFrame and the tab wasn't painting. */
      function inkSettle() {
        navInk.style.transition = 'none';
        inkRest();
        void navInk.offsetWidth; /* flush, so the restored transition doesn't animate from 0 */
        navInk.style.transition = '';
      }

      navEl.classList.add('has-ink');
      inkSettle();
      /* link widths shift once the webfont swaps in — re-measure rather than sit misaligned */
      window.addEventListener('load', inkSettle);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(inkSettle);

      navLinks.forEach(function (link) {
        link.addEventListener('mouseenter', function () { inkTo(link, true); });
        link.addEventListener('focus', function () { inkTo(link, true); });
      });
      navEl.addEventListener('mouseleave', inkRest);
      navEl.addEventListener('focusout', function (e) {
        if (!navEl.contains(e.relatedTarget)) inkRest();
      });
      /* resize: jump, don't glide across the bar */
      window.addEventListener('resize', inkSettle, { passive: true });
    }
  }

  /* ---------------- OUR STANDARD: third-party review rotator ----------------
     Reads a JSON file from Settings → Files (rating/review/author/date), shows ONE
     review at a time and slides the next in. Self-hides if the file is missing or has
     nothing usable, so a bad upload can never leave an empty band on the homepage.
     Pauses on hover/focus. Under prefers-reduced-motion it does not auto-advance. */

  var reviewBand = document.querySelector('[data-reviews]');
  if (reviewBand) {
    var rvSlot = reviewBand.querySelector('[data-review-slot]');
    var rvUrl = reviewBand.getAttribute('data-reviews-url');
    var rvInterval = (Number(reviewBand.getAttribute('data-reviews-interval')) || 6) * 1000;
    var rvMinLen = Number(reviewBand.getAttribute('data-reviews-min-len')) || 0;
    var rvReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var rvPaused = false;
    var rvIdx = 0;
    var rvData = [];
    var rvCurrent = null;

    var rvEsc = function (s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    };

    function rvStars(n) {
      var r = Math.max(0, Math.min(5, Math.round(Number(n) || 0)));
      var out = '<span class="m-stars" role="img" aria-label="' + r + ' out of 5 stars">';
      for (var i = 1; i <= 5; i++) {
        out += '<svg class="m-star' + (i <= r ? ' is-on' : '') + '" viewBox="0 0 24 24" aria-hidden="true">' +
               '<path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01z"/></svg>';
      }
      return out + '</span>';
    }

    function rvRender(item) {
      var el = document.createElement('div');
      el.className = 's-quote__review-item is-enter';
      var meta = [item.author || 'Verified buyer', item.date].filter(Boolean).join(' · ');
      el.innerHTML = rvStars(item.rating) +
        '<p class="s-quote__review-text">&ldquo;' + rvEsc(item.review) + '&rdquo;</p>' +
        '<span class="s-quote__review-meta">' + rvEsc(meta) + '</span>';
      rvSlot.appendChild(el);
      /* two frames so the browser paints is-enter before it's removed → transition runs */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { el.classList.remove('is-enter'); });
      });
      if (rvCurrent) {
        var old = rvCurrent;
        old.classList.add('is-leave');
        setTimeout(function () { if (old.parentNode) old.parentNode.removeChild(old); }, 560);
      }
      rvCurrent = el;
    }

    function rvNext() {
      if (rvPaused || rvData.length < 2) return;
      rvIdx = (rvIdx + 1) % rvData.length;
      rvRender(rvData[rvIdx]);
    }

    fetch(rvUrl)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!Array.isArray(data)) return;
        rvData = data.filter(function (d) {
          return d && typeof d.review === 'string' && d.review.trim().length >= rvMinLen;
        });
        if (!rvData.length) return; /* nothing usable — leave the band hidden */
        for (var i = rvData.length - 1; i > 0; i--) { /* shuffle */
          var j = Math.floor(Math.random() * (i + 1));
          var t = rvData[i]; rvData[i] = rvData[j]; rvData[j] = t;
        }
        reviewBand.hidden = false;
        rvRender(rvData[0]);
        if (!rvReduced && rvData.length > 1) setInterval(rvNext, rvInterval);
      })
      .catch(function () { /* band stays hidden — never show an empty shell */ });

    ['mouseenter', 'focusin'].forEach(function (e) {
      reviewBand.addEventListener(e, function () { rvPaused = true; });
    });
    ['mouseleave', 'focusout'].forEach(function (e) {
      reviewBand.addEventListener(e, function () { rvPaused = false; });
    });
    document.addEventListener('visibilitychange', function () { rvPaused = document.hidden; });
  }

  /* ---------------- THE RECORD: Amazon affiliate layer ----------------
     GATED: only runs when the article body carries data-amzn-tag (i.e. the
     Amazon Associates tag is set in theme settings → Monetization). Decorates
     amazon links with the tag + rel=sponsored and a native hover/tap card:
     OUR live price (via the same suggest.json the header search uses) next to
     a CHECK AMAZON PRICE button. We never render Amazon's price — displaying
     it requires their PA-API (phase 2). Hover on desktop, first-tap on touch. */

  var amznBody = document.querySelector('[data-amzn-tag]');
  if (amznBody) {
    var amznTag = amznBody.getAttribute('data-amzn-tag');
    var amznLinks = amznBody.querySelectorAll('a[href*="amazon."], a[href*="amzn.to"]');

    var amznEsc = function (s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    };

    if (amznTag && amznLinks.length) {
      amznLinks.forEach(function (link) {
        var href = link.getAttribute('href') || '';
        if (/amazon\./.test(href)) {
          try {
            var u = new URL(href, window.location.origin);
            u.searchParams.set('tag', amznTag);
            link.href = u.toString();
          } catch (e) { /* malformed href — leave as authored */ }
        }
        /* amzn.to short links already embed a tag; decorate but don't rewrite */
        link.setAttribute('rel', 'sponsored noopener');
        link.setAttribute('target', '_blank');
        link.classList.add('m-amzn-link');
        link.setAttribute('data-amzn', '');
      });

      var amznCard = null;
      var amznFor = null;      /* link the card is currently attached to */
      var amznHideTimer = null;
      var amznCache = {};
      var touchMode = window.matchMedia('(hover: none)').matches;

      function amznEnsureCard() {
        if (amznCard) return amznCard;
        amznCard = document.createElement('div');
        amznCard.className = 'm-amzn-card';
        amznCard.hidden = true;
        amznCard.addEventListener('mouseenter', function () { clearTimeout(amznHideTimer); });
        amznCard.addEventListener('mouseleave', amznScheduleHide);
        document.body.appendChild(amznCard);
        return amznCard;
      }

      function amznHide() {
        if (amznCard) amznCard.hidden = true;
        amznFor = null;
      }
      function amznScheduleHide() {
        clearTimeout(amznHideTimer);
        amznHideTimer = setTimeout(amznHide, 250);
      }

      function amznLookup(q) {
        if (q in amznCache) return Promise.resolve(amznCache[q]);
        return fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
              '&resources[type]=product&resources[limit]=1&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var p = (data.resources && data.resources.results && data.resources.results.products || [])[0] || null;
            amznCache[q] = p;
            return p;
          })
          .catch(function () { return null; });
      }

      function amznPosition(link) {
        var r = link.getBoundingClientRect();
        var w = 280;
        var left = Math.min(Math.max(r.left, 12), window.innerWidth - w - 12);
        var top = r.bottom + 8;
        if (top + 220 > window.innerHeight) top = Math.max(12, r.top - 8 - 200);
        amznCard.style.left = left + 'px';
        amznCard.style.top = top + 'px';
      }

      function amznRender(link, p) {
        var c = amznEnsureCard();
        var goBtn = '<a class="m-amzn-card__go" href="' + amznEsc(link.href) + '" target="_blank" rel="sponsored noopener">CHECK AMAZON PRICE &rarr;</a>';
        var fine = '<span class="m-amzn-card__fine">AFFILIATE LINK — WE MAY EARN A COMMISSION</span>';
        if (p && p.available !== false) {
          var img = p.featured_image && p.featured_image.url;
          if (img) img += (img.indexOf('?') === -1 ? '?' : '&') + 'width=88';
          var thumb = img
            ? '<img class="m-amzn-card__thumb" src="' + amznEsc(img) + '" width="44" height="44" alt="" loading="lazy">'
            : '<span class="m-amzn-card__thumb" aria-hidden="true"></span>';
          c.innerHTML =
            '<span class="m-amzn-card__kicker">IN THE VAULT — SHIPS FROM US</span>' +
            '<a class="m-amzn-card__ours" href="' + amznEsc(p.url) + '">' +
              thumb +
              '<span class="m-amzn-card__title">' + amznEsc(p.title) + '</span>' +
              '<span class="m-amzn-card__price">$' + amznEsc(p.price) + '</span>' +
            '</a>' +
            '<span class="m-amzn-card__or">— OR —</span>' + goBtn + fine;
        } else {
          c.innerHTML =
            '<span class="m-amzn-card__kicker">' + (p ? 'SOLD OUT AT MILLENNIUM' : 'NOT IN THE VAULT') + '</span>' +
            goBtn + fine;
        }
        amznPosition(link);
        c.hidden = false;
        amznFor = link;
      }

      function amznShow(link) {
        clearTimeout(amznHideTimer);
        amznLookup(link.textContent.trim()).then(function (p) { amznRender(link, p); });
      }

      amznLinks.forEach(function (link) {
        link.addEventListener('mouseenter', function () { if (!touchMode) amznShow(link); });
        link.addEventListener('mouseleave', function () { if (!touchMode) amznScheduleHide(); });
        link.addEventListener('focus', function () { amznShow(link); });
        link.addEventListener('blur', amznScheduleHide);
        link.addEventListener('click', function (e) {
          /* touch: first tap opens the card (hover doesn't exist); its buttons navigate */
          if (touchMode && amznFor !== link) {
            e.preventDefault();
            amznShow(link);
          }
        });
      });

      document.addEventListener('click', function (e) {
        if (amznCard && !amznCard.hidden &&
            !e.target.closest('.m-amzn-card') && !e.target.closest('[data-amzn]')) {
          amznHide();
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') amznHide();
      });
      window.addEventListener('scroll', function () {
        if (amznCard && !amznCard.hidden && amznFor) amznPosition(amznFor);
      }, { passive: true });
    }
  }

  /* ---------------- PDP variants ---------------- */

  var variantJson = document.getElementById('ProductVariants');
  if (variantJson) {
    var variants = JSON.parse(variantJson.textContent);
    var selects = document.querySelectorAll('[data-option-select]');
    selects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
        var match = variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === chosen[i]; });
        });
        if (!match) return;
        document.querySelectorAll('[data-variant-id-input]').forEach(function (i) { i.value = match.id; });
        document.querySelectorAll('[data-variant-price]').forEach(function (el) {
          el.textContent = match.price_formatted || el.textContent;
        });
        var stockChips = document.querySelectorAll('[data-variant-stock]');
        stockChips.forEach(function (el) { el.textContent = match.available ? 'IN STOCK' : 'SOLD OUT'; });
        document.querySelectorAll('[data-atc-button]').forEach(function (b) {
          b.toggleAttribute('disabled', !match.available);
          var label = b.getAttribute('data-atc-label') || 'ADD TO CART';
          b.textContent = match.available ? label.replace('%price%', match.price_formatted || '') : 'SOLD OUT';
        });
      });
    });
  }
})();
